export default __webpack_public_path__ + "static/media/pic91.e4fb50b3.jpg";